module.exports = __webpack_public_path__ + "img/app2img.45222289.png";